import ApolloClientService from './apolloclient.service'
import { constants } from '../constants'

const service = new ApolloClientService()

const wrap = (call) =>
  new Promise((resolve, reject) => {
    call
      .then((data) => {
        if (data && data.status == constants.MESSAGE.SUCCESS) {
          resolve(data)
        } else {
          reject({ ...(data || {}), error: true })
        }
      })
      .catch((err) => {
        console.log(err)
        reject({ error: true })
      })
  })

export default class Maintenance {
  getMaintenanceMode = () => wrap(service.getMaintenanceMode())

  setMaintenanceMode = (params) => wrap(service.setMaintenanceMode(params))

  getActiveUsers = (params) => wrap(service.getActiveUsers(params))
}
